// Presentation only: official numbers are always supplied by a future backend.
export function getPrimaryServiceLabel({ selectedServices = [], services = [], fullPackage = false }) {
    const selected = new Set(selectedServices);
    if (fullPackage && selected.has('sst_mensual') && selected.has('rrhh_mensual')) return 'Paquete Full';
    if (selected.has('sst_mensual')) return 'Outsourcing SST';
    if (selected.has('rrhh_mensual')) return 'Outsourcing RRHH';
    const principal = services.filter(service => selected.has(service.id))
        .sort((a, b) => (Number(b.finalPrice) || 0) - (Number(a.finalPrice) || 0) || a.id.localeCompare(b.id))[0];
    return principal?.title || 'Servicios Zaphy';
}

export function sanitizeDocumentPart(value, fallback) {
    const clean = Array.from(String(value || '').normalize('NFC'))
        .map(character => character.charCodeAt(0) < 32 || character.charCodeAt(0) === 127 ? ' ' : character).join('')
        .replace(/[<>:"/\\|?*]/g, ' ')
        .replace(/\s+/g, ' ').trim().replace(/^[. ]+|[. ]+$/g, '')
        .slice(0, 70).replace(/[. ]+$/g, '');
    return clean || fallback;
}

export function buildProposalDocumentName({ quoteNumber, company, contactName, ...selection }) {
    return [
        sanitizeDocumentPart(quoteNumber, 'Cotización'),
        sanitizeDocumentPart(company, sanitizeDocumentPart(contactName, 'Cliente')),
        sanitizeDocumentPart(getPrimaryServiceLabel(selection), 'Servicios Zaphy')
    ].join(' - ');
}
